import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface SPScreenSize {
  SPWidth: number;
  SPHeight: number;
}

export interface SPScrollPayload extends SPScreenSize {
  SPSscrollTop: number;
}

export function isSPScrollPayload(data: any): data is SPScrollPayload {
  return data.SPSscrollTop !== undefined && data.SPWidth !== undefined && data.SPHeight !== undefined;
}

export const toggleSSModalMode = createAsyncThunk(
  'ui/toggleSSModalMode',
  async (payload: { open: boolean; meta: any }, { dispatch }) => {
    window.parent.postMessage(
      {
        type: 'ss-modal-is-open',
        payload: {
          open: payload.open,
          meta: payload.meta,
        },
      },
      '*'
    );
  }
);

interface UISliceState {
  screenSize: SPScrollPayload;
  mainToggle: boolean;
  theme: string;
  isMobileFullHeight?: {
    iframeOffsetTop: number;
  };
  SP2Config?: {
    SP2Env?: string;
  };
  SPSiFrameHeight: number;
}

const initialState: UISliceState = {
  screenSize: {
    SPWidth: window.innerWidth,
    SPHeight: window.innerHeight,
    SPSscrollTop: 0,
  },
  mainToggle: false,
  theme: '',
  SP2Config: {
    SP2Env: 'production',
  },
  SPSiFrameHeight: 0,
};

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    updateScreenSize: (state, action: PayloadAction<SPScrollPayload>) => {
      state.screenSize = action.payload;
    },
    toggleMainAccordion: (state) => {
      state.mainToggle = !state.mainToggle;
    },
    setMainAccordion: (state, action: PayloadAction<boolean>) => {
      state.mainToggle = action.payload;
    },
    setTheme: (state, action: PayloadAction<string>) => {
      state.theme = action.payload;
    },
    // setIsMobileFullHeight: (state, action: PayloadAction<boolean>) => {
    //   state.isMobileFullHeight = action.payload;
    // },
    setIsMobileFullHeight: (state, action: PayloadAction<{ iframeOffsetTop: number }>) => {
      state.isMobileFullHeight = action.payload;
    },
    setSP2Config: (state, action: PayloadAction<{ SP2Domain?: string; SP2Env?: string }>) => {
      state.SP2Config = action.payload;
    },
    setSPSiFrameHeight: (state, action: PayloadAction<number>) => {
      state.SPSiFrameHeight = action.payload;
      window.parent.postMessage({ SPSiFrameHeight: action.payload }, '*');
    },
  },
});

export const {
  updateScreenSize,
  toggleMainAccordion,
  setMainAccordion,
  setTheme,
  setIsMobileFullHeight,
  setSP2Config,
  setSPSiFrameHeight,
} = uiSlice.actions;

const uiReducer = uiSlice.reducer;

export default uiReducer;
